export const AMS_BASE_URL = "https://ams.be.thecloudworlds.com/api/v1";
export const AMS_SUBSCRIBE_NEWSLETTER_ENDPOINT =
  AMS_BASE_URL + "/subscribe-newsletter";
